module.exports = __webpack_public_path__ + "static/img/djbg.aae194b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/djbg.png
// module id = O9IU
// module chunks = 0